import moment from 'moment';

export const SHORT_DATE_TIME_FORMAT = 'YYYY-MM-DD, h:mm A';
export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';

export const range = (start: number, end: number) => {
  const result = [];
  for (let i = start; i < end; i += 1) {
    result.push(i);
  }
  return result;
};

export const disabledTime = (current: moment.MomentInput) => {
  const currentD = moment(current).format(SHORT_DATE_FORMAT);
  const start = moment().format(SHORT_DATE_FORMAT);
  if (new Date(currentD).getTime() === new Date(start).getTime()) {
    const hoursDisable = +moment().format('HH');
    let minutesDisable = 0;
    let secondsDisable = 0;

    if (hoursDisable >= +moment(current).format('HH')) {
      minutesDisable = +moment().format('mm');
    }

    if (
      hoursDisable >= +moment(current).format('HH') &&
      minutesDisable >= +moment(current).format('mm')
    ) {
      secondsDisable = +moment().format('ss');
    }
    return {
      disabledHours: () => range(0, 24).splice(0, hoursDisable),
      disabledMinutes: () => range(0, minutesDisable),
      disabledSeconds: () => range(0, secondsDisable),
    };
  }

  return {
    disabledHours: () => [],
    disabledMinutes: () => [],
    disabledSeconds: () => [],
  };
};
